import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function UpgradeCancel() {
  return (
    <div className="space-y-4" data-testid="upgrade-cancel-page">
      <h1 className="font-display text-3xl font-black">Checkout cancelled</h1>
      <div className="nb-card-lg p-8 text-center space-y-4" style={{ background: "#fdecc8" }}>
        <XCircle size={48} strokeWidth={2.5} className="mx-auto" />
        <div className="font-display font-black text-2xl">No worries — no charge was made</div>
        <div className="text-sm font-bold">You can come back and upgrade any time.</div>
        <div className="flex justify-center gap-2">
          <Link to="/upgrade" className="nb-btn nb-btn-dark inline-flex" data-testid="try-again">
            Try again
          </Link>
          <Link to="/" className="nb-btn nb-btn-secondary inline-flex">
            Back home
          </Link>
        </div>
      </div>
    </div>
  );
}
